
export interface MapYard {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  lat?: number;
  lng?: number;
}

/** Maps a cmdGetYards row (camelCased, lat/lng as strings) to a MapYard. */
export function toMapYard(row: any): MapYard {
  const lat = parseFloat(row.latitude);
  const lng = parseFloat(row.longitude);

  return {
    id: row.yardID,
    name: row.yardName || 'Unnamed Yard',
    address: row.streetAddress || '',
    city: row.city || '',
    state: row.state || '',
    lat: isNaN(lat) ? undefined : lat,
    lng: isNaN(lng) ? undefined : lng
  };
}

export function yardFullAddress(yard: MapYard): string {
  return [yard.address, yard.city, yard.state].filter(Boolean).join(', ');
}
